import React from 'react';
import Select from 'react-select';
import { Maps } from '../data/MapIcons';
import { customDarkSelectStyles } from './CustomDarkSelectStyles';

const MapCustomSelect = ({ selectedOption, onOptionChange }) => {

  const options = Object.keys(Maps).map((map) => ({
    value: map,
    label: map,
  }));

  const customOption = ({ innerProps, label, isFocused }) => (
    <div
      {...innerProps}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '8px 10px',
        backgroundColor: isFocused ? '#3a3a3a' : '#2c2c2c',
        color: '#f1f1f1',
        cursor: 'pointer',
      }}
    >
      <img
        src={Maps[label].splash}
        alt=""
        style={{ width: '48px', height: '24px', borderRadius: '3px' }}
      />
      {label}
    </div>
  );

  return (
    <Select
      isMulti={false}
      options={options}
      value={options.find(o => o.value === selectedOption)}
      onChange={(option) => onOptionChange(option)}
      components={{ Option: customOption }}
      styles={customDarkSelectStyles}
      placeholder="Maps"
    />
  );
};

export default MapCustomSelect;